import { DOMAIN_CIAM_LOGIN_PREFIX, OKTA_DEFAULT_SCOPE } from 'global/constants';

import { getOktaClientId, getOktaDomain, isOktaProvider } from './IamUtils';
import { getDomainCIAMLoginPrefixByStage, getDomainPrefixByStage, isLocal } from './StageUtils';
import { getTenantInfo } from './tenantUtil';

/**
 * Check if an url is external url or not
 * We are assuming that any url which starts with https is an external url
 * @param url - value to check
 * @return {boolean}
 */
export const isExternal = (url) => /^https?:\/\//.test(url);

export const getLinkToMyData = (currentUrl) => {
  let newUrl = currentUrl.split('/de')[0];
  const newPath = '/de/my-data.html';
  newUrl += newPath;

  return newUrl;
};

const getPath = (tenantId) => {
  const tenantInfo = getTenantInfo(tenantId);
  const base = `/content/revu-global/e-fix/${tenantInfo.aemPath}/de.html`;
  return {
    HOMEPAGE: `${base}`,
    EXPERT_TELEPHONE: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/expertentelefon.html`,
    EXPERT_TELEPHONE_CONNECTION_SERVICE: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/expertentelefon/anschlussservice.html`,
    EXPERT_TELEPHONE_INSTALLER_SERVICE: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/expertentelefon/installateur-service.html`,
    EXPERT_TELEPHONE_HELP_IN_PLACE: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/expertentelefon/hilfe-vor-ort.html`,
    EXPERT_TELEPHONE_IT_HELP: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/expertentelefon/it-hilfe.html`,
    EXPERT_TELEPHONE_NETWORK_CONNECTION: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/expertentelefon/netzanschluss.html`,
    EXPERT_TELEPHONE_SERVICE_PROVIDER: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/expertentelefon/dienstleister-zahlersetzung.html`,
    EXPERT_TELEPHONE_SUPPORT_HOTLINE: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/expertentelefon/map-support-hotline.html`,
    EVENTS_OVERVIEW: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/informationskanal/veranstaltungen.html`,
    ARTICLES_OVERVIEW: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/informationskanal/fachbeitraege.html`,
    EVENTS_AND_ARTICLES_OVERVIEW: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/informationskanal.html`,
    LEXIKON_HOME: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/lexikon/lexikon-home.html`,
    DISORDER: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/stoerungen.html`,
    MY_DATA: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/my-data.html`,
    MY_TASKS: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/my-data/my-tasks.html`,
    MY_TASKS_DETAIL: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/my-data/my-tasks/taskdetailpage.html`,
    DEB: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/my-data/datenerfassungsblatt.html`,
    PRIVACY: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/my-data/data-privacy.html`,
    SUB_ACCOUNTS: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/my-data/zusatzkonten.html`,
    DELETE_COMPANY: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/my-data/delete-company.html`,
    NEWSLETTER: `/content/revu-global/e-fix/${tenantInfo.aemPath}/de/newsletter.html`,
  };
};

export const getHomepagePath = () => getPath().HOMEPAGE;

export const getExpertTelephonePath = () => getPath().EXPERT_TELEPHONE;

export const getExpertTelephoneConnectionServicePath = () =>
  getPath().EXPERT_TELEPHONE_CONNECTION_SERVICE;

export const getExpertTelephoneInstallerServicePath = () =>
  getPath().EXPERT_TELEPHONE_INSTALLER_SERVICE;

export const getExpertTelephoneHelpInPlacePath = () => getPath().EXPERT_TELEPHONE_HELP_IN_PLACE;

export const getExpertTelephoneItHelpPath = () => getPath().EXPERT_TELEPHONE_IT_HELP;

export const getExpertTelephoneNetworkConnectionPath = () =>
  getPath().EXPERT_TELEPHONE_NETWORK_CONNECTION;

export const getExpertTelephoneServiceProviderPath = () =>
  getPath().EXPERT_TELEPHONE_SERVICE_PROVIDER;

export const getExpertTelephoneSupportHotlinePath = () =>
  getPath().EXPERT_TELEPHONE_SUPPORT_HOTLINE;
export const getEventsOverviewPath = () => getPath().EVENTS_OVERVIEW;

export const getArticlesOverviewPath = () => getPath().ARTICLES_OVERVIEW;

export const getEventsAndArticlesOverviewPath = () => getPath().EVENTS_AND_ARTICLES_OVERVIEW;

export const getLexikonHomePath = () => getPath().LEXIKON_HOME;

export const getDisorderPath = () => getPath().DISORDER;

export const getMyDataPath = () => getPath().MY_DATA;

export const getMyTasksDetailPath = () => getPath().MY_TASKS_DETAIL;

export const getMyTasksPath = () => getPath().MY_TASKS;

export const getDEBPath = () => getPath().DEB;

export const getPrivacyPath = () => getPath().PRIVACY;

export const getSubAccountsPath = () => getPath().SUB_ACCOUNTS;

export const getDeleteCompanyPath = () => getPath().DELETE_COMPANY;

export const getTenantLandingPage = (tenantId) => {
  const tenantInfo = getTenantInfo(tenantId);
  const landingPage = `https://${getDomainPrefixByStage()}e-fix.info/${
    tenantInfo.aemPath
  }/index.html`;

  if (window.location.host.includes('app-e-fix-frontend-dev-new.azurewebsites.net')) {
    return `${landingPage}?source=azure-dev-frontend`;
  }

  return landingPage;
};

export const getBaseUrl = (isAEM = false) => {
  let baseUrl = '';
  const tenantSubDomain = getTenantInfo().subDomain;
  if (isLocal()) {
    baseUrl = `http://localhost:${
      isAEM ? process.env.REACT_APP_AEM_PORT : process.env.REACT_APP_PORT
    }`;
  } else {
    baseUrl = `https://${getDomainPrefixByStage()}${tenantSubDomain}.e-fix.info`;
  }
  return baseUrl;
};

export const getHomepageUrlByTenantId = (tenantId) => {
  let baseUrl = '';
  const tenantSubDomain = getTenantInfo(tenantId).subDomain;
  if (isLocal()) {
    baseUrl = `http://localhost:${process.env.REACT_APP_PORT}`;
  } else {
    baseUrl = `https://${getDomainPrefixByStage()}${tenantSubDomain}.e-fix.info`;
  }

  return baseUrl + getPath(tenantId).HOMEPAGE;
};

export const getAuthRedirectUrl = (isCIAM, tenantId) => {
  const isNewFrontend = window.location.pathname === '/de/efix-portal';
  const baseUrl =
    !isLocal() && isNewFrontend
      ? `${window.location.origin}${window.location.pathname}`
      : getHomepageUrlByTenantId(tenantId);

  return `${baseUrl}${isCIAM ? '' : '?auth=EIAM'}`;
};

export const getEventParticipationUrl = (eventId) => {
  const tenantInfo = getTenantInfo();
  const baseUrl = getBaseUrl();
  // TODO - change to real path of public page to enter event participation code
  return `${baseUrl}/content/revu-global/e-fix/${tenantInfo.aemPath}/de/public/teilnahmecode-eingabe.html?eventId=${eventId}`;
};

const getCIAMLogoutUrl = () => {
  const tenantInfo = getTenantInfo();

  if (isLocal()) {
    return `https://${
      DOMAIN_CIAM_LOGIN_PREFIX.LOCAL
    }e-fix.info/secur/logout.jsp?retUrl=${encodeURIComponent(
      `/services/oauth2/authorize?client_id=3MVG9sSN_PMn8tjSodyD28jSJpyXAPKdt_YdgBgU1A7PjKW2ILbQ_wqDrjN_qXt3l39cMWsDx433YvdND71Wy&redirect_uri=${getHomepageUrlByTenantId()}&response_type=code&scope=openid`
    )}`;
  }
  return `https://${getDomainCIAMLoginPrefixByStage()}e-fix.info/secur/logout.jsp?retUrl=https://${getDomainCIAMLoginPrefixByStage()}e-fix.info/CommunitiesLandingForNetzportal?redirectUrl=${getTenantLandingPage()}`;
};
const getEIAMLogoutUrl = () => {
  const tenantInfo = getTenantInfo();

  const azureTenantId = 'b914a242-e718-443b-a47c-6b4c649d8c0a';
  let postLogoutRedirectUri = '';

  if (isLocal()) {
    postLogoutRedirectUri = encodeURIComponent(
      `http://localhost:3001/content/revu-global/e-fix/${tenantInfo.aemPath}/de.html?auth=EIAM`
    );
    return `https://login.microsoftonline.com/b914a242-e718-443b-a47c-6b4c649d8c0a/oauth2/v2.0/authorize?client_id=54d66672-abf2-4a75-913c-0ee8d21f7e74&scope=54d66672-abf2-4a75-913c-0ee8d21f7e74%2F.default&response_type=code&redirect_uri=${postLogoutRedirectUri}`;
  }
  postLogoutRedirectUri = encodeURIComponent(getTenantLandingPage());

  return `https://login.microsoftonline.com/${azureTenantId}/oauth2/v2.0/logout?post_logout_redirect_uri=${postLogoutRedirectUri}`;
};
const getOktaAuthorizeUrl = (tenantId) => {
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: getOktaClientId(tenantId),
    // Must match Auth.jsx's `redirectUrl` byte for byte - the backend replays it in the exchange.
    redirect_uri: getHomepageUrlByTenantId(tenantId),
    scope: OKTA_DEFAULT_SCOPE,
  });

  return `https://${getOktaDomain()}/authorize?${params.toString()}`;
};

const getOktaLogoutUrl = (tenantId) => {
  const params = new URLSearchParams({
    client_id: getOktaClientId(tenantId),
    returnTo: isLocal() ? getBaseUrl() : getHomepageUrlByTenantId(tenantId),
  });

  return `https://${getOktaDomain()}/v2/logout?${params.toString()}`;
};

/**
 * Locally the app cannot tell a CIAM from an EIAM user, so it asks.
 */
const resolveIsCIAM = (isCIAM) => {
  if (!isLocal()) {
    return isCIAM;
  }

  return window.confirm('Cancel for EIAM, OK for CIAM');
};

export const getLogoutRedirectUrl = (isCIAM) => {
  const useCIAM = resolveIsCIAM(isCIAM);

  if (useCIAM) {
    return isOktaProvider() ? getOktaLogoutUrl() : getCIAMLogoutUrl();
  }
  return getEIAMLogoutUrl();
};

/**
 * Where an unauthenticated visitor is sent to sign in. Salesforce reuses the logout URL (its
 * retUrl points at /services/oauth2/authorize); Okta gets a plain OIDC authorization request.
 */
export const getLoginRedirectUrl = (isCIAM) => {
  const useCIAM = resolveIsCIAM(isCIAM);

  if (useCIAM) {
    return isOktaProvider() ? getOktaAuthorizeUrl() : getCIAMLogoutUrl();
  }
  return getEIAMLogoutUrl();
};

export const getLexikonUrl = () => `${getBaseUrl(true)}${getLexikonHomePath()}`;

export const getNewsletterCallbackUrl = () => `${getBaseUrl()}${getPath().NEWSLETTER}`;

export const getAuthEIAMUrl = (domainPrefix) => {
  let url = '';
  if (isLocal()) {
    url = `http://localhost:${process.env.REACT_APP_BE_PORT}/api/eiam/token`;
  } else {
    url = `https://${domainPrefix || getDomainPrefixByStage()}backend.e-fix.info/api/eiam/token`;
  }
  return url;
};

export const getAuthCIAMUrl = (domainPrefix) => {
  let url = '';
  if (isLocal()) {
    url = `http://localhost:${process.env.REACT_APP_BE_PORT}/api/ciam/token`;
  } else {
    url = `https://${domainPrefix || getDomainPrefixByStage()}backend.e-fix.info/api/ciam/token`;
  }
  return url;
};
export const getSanitzedAttachmentUrl = (attachmentUrl) => {
  const NEEDLE = 'http://localhost:4502';
  const NODE_ENV_DEV = 'development';

  if (
    !attachmentUrl ||
    process.env.NODE_ENV === NODE_ENV_DEV ||
    !process.env.REACT_APP_GRAPHQL_ENDPOINT ||
    !process.env.REACT_APP_AEM_ENDPOINT.length ||
    attachmentUrl.indexOf(NEEDLE) === -1
  ) {
    return attachmentUrl;
  }

  return attachmentUrl.replace(NEEDLE, process.env.REACT_APP_AEM_ENDPOINT);
};
